// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error(
    "Missing Supabase environment variables. " +
      "Ensure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set.",
  );
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Guard localStorage so the module doesn't throw in non-browser contexts
// (e.g. Vitest, SSR, or any Node.js script that imports this file).
const storage = typeof localStorage !== "undefined" ? localStorage : undefined;

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      storage,
      persistSession: true,
      autoRefreshToken: true,
    },
  },
);
